import firebase from 'firebase';

var firebaseConfig = {
    apiKey: "AIzaSyAWwJKFHfUQhtPb908MbvVvxnpXXrmOj08",
    authDomain: "sample-auth-d0c44.firebaseapp.com",
    databaseURL: "https://sample-auth-d0c44.firebaseio.com",
    projectId: "sample-auth-d0c44",
    storageBucket: "sample-auth-d0c44.appspot.com",
    messagingSenderId: "693778352033",
    appId: "1:693778352033:web:b5697126cfa5c46b1aade0"
  };
const fire = firebase.initializeApp(firebaseConfig);

export default fire;